export const authStepMap = {
  START_AUTH: "start_auth",
  PROCESSING_AUTH: "processing_auth",
  SUCCESS_AUTH: "success_auth",
};
